import React, { Component } from "react";

export default class FooterModal extends Component {
	render() {
		return (
            <div className="footer-modal">
                {this.props.children}
            </div>)
	}
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/FooterModal.js